var React = require('react');
var Griddle = require('griddle-react');

var UserStatus = require('../../../containers/Admin/Users/UserStatus');
var Files = require('../../../containers/Admin/Users/Files');

const rowData = [
	{
    	"columnName": "id",
    	"order": 1,
    	"visible": false
	},
	{
		"columnName": "name",
		"order": 2,
		"visible": true,
		"displayName": "Nome"
	},
	{
		"columnName": "email",
		"order": 3,
		"visible": true,
		"displayName": "Email",
		"sortable": false
	},
	{
		"columnName": "cnpj",
		"order": 4,
		"visible": true,
		"displayName": "CNPJ",
		"sortable": false
	},
	{
		"columnName": "phone",
		"order": 5,
		"visible": true,
		"displayName": "Telefone",
		"sortable": false
	},
	{
		"columnName": "paymentDay",
		"order": 6,
		"visible": true,
		"displayName": "Vencimento",
		"sortable": false
	},
	{
    	"columnName": "files",
    	"order": 7,
    	"visible": true,
    	"displayName": "Arquivos",
    	"sortable": false,
    	"customComponent": Files
	},
	{
		"columnName": "status",
		"order":  8,
		"visible": true,
		"displayName": "Status",
		"customComponent": UserStatus
	},
	{
    	"columnName": "userType",
    	"order": 9,
    	"visible": false
	}
];

var Companies = React.createClass({

	render: function() {
		var me = this;

		return (
			<Griddle 
				results={me.props.data}
				columnMetadata={rowData}
				showFilter={true}
				resultsPerPage={20}
				useGriddleStyles={false}
				tableClassName="table"
				sortDefaultComponent={<span className="icon-sort"></span>}
				sortAscendingComponent={<span className="icon-sort-down"></span>}
				sortDescendingComponent={<span className="icon-sort-up"></span>}
				filterPlaceholderText="Pesquisar"
				nextText="Próxima"
				previousText="Anterior"
				columns={["name", "email", "cnpj", "phone", "paymentDay", "files", "status"]}
			/>
		);
	}

});

module.exports = Companies;


// WEBPACK FOOTER //
// ./src/components/Admin/Users/Companies.jsx